import { Action } from 'redux';
import { CheckHasUnseenUserNotifications, CheckHasUnseenUserNotificationsSucceeded } from '../../../app/actions/AppActionTypes';
import { isActionFactory } from '../../../app/actions/isActionFactory';

export interface CheckHasUnseenUserNotificationsAction extends Action { }

export interface CheckHasUnseenUserNotificationsSuccededAction extends Action {
  hasUnseenUserNotifications: boolean;
}

// TODO: failure, if the UI cares about it at all

export function checkHasUnseenUserNotificationsAction(): CheckHasUnseenUserNotificationsAction {
  return {
    type: CheckHasUnseenUserNotifications,
  };
}

export function checkHasUnseenUserNotificationsSucceededAction(hasUnseenUserNotifications: boolean): CheckHasUnseenUserNotificationsSuccededAction {
  return {
    type: CheckHasUnseenUserNotificationsSucceeded,
    hasUnseenUserNotifications: hasUnseenUserNotifications
  };
}

export const isCheckHasUnseenUserNotificationsAction = isActionFactory<CheckHasUnseenUserNotificationsAction>(CheckHasUnseenUserNotifications);

export const isCheckHasUnseenUserNotificationsSucceededAction = isActionFactory<CheckHasUnseenUserNotificationsSuccededAction>(CheckHasUnseenUserNotificationsSucceeded);
